module.exports = __webpack_public_path__ + "assets/img/succ5.5cf7e45c.png";